import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface PromptSectionProps {
  prompt: string;
  isDirty?: boolean;
  onChange: (value: string) => void;
}

const PromptSection: React.FC<PromptSectionProps> = ({ 
  prompt,
  onChange 
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>どんな内容が重要ですか？</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 px-4">
        <Textarea
          value={prompt}
          onChange={(e) => onChange(e.target.value)}
          rows={6}
          className="font-mono"
          placeholder="例：商品の購入を検討している方からの問い合わせは重要です。"
        />
        <Alert>
          <AlertDescription>
            この設定は、次回の問い合わせから反映されます。
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
};

export default PromptSection;
